import React, { useState, useEffect, createRef } from 'react';
import styled from 'styled-components';
import arrow_icon from '../../images/arrow_icon.png';
import share_icon from '../../images/share_icon.png';
import lock_gray from '../../images/lock_gray.png';
import { Link, useHistory } from 'react-router-dom';
import constants from 'utils/constants';
import { Helmet } from 'react-helmet-async';
import KakaoShareButton from 'components/containers/common/KakaoShareButton';
import DotButton from 'components/presenters/button/DotButton'
import { useSelector } from 'react-redux';

export default function GroupTitle({ groupInfo, borderbottom, token, handleModal }) {
  const userInfo = useSelector((state) => {
    return state['userInfo'];
  })
  const [shareQueryString, setshareQueryString] = useState('');
  useEffect(() => {
    if (token) {
      setshareQueryString(`token=${token}`);
    }
  }, [token]);
  const kakaoButton = createRef();
  const history = useHistory();
  const clickShareButton = async () => {
    try
    {
      // const shareTitle = groupInfo['title'];
      // const shareDescription = groupInfo['description'];
      // const shareImg = groupInfo['group_cover_img'] ? `${constants.imagePath}/group_cover_img/${groupInfo['group_cover_img']}` : null;

      // if(userInfo['isMobile'] && userInfo['isApp'])
      // {
      //   if(userInfo['deviceType'] === 'iOS')
      //   {
      //     const currURL = window.location.href;
      //     if(navigator.share)
      //     {
      //       await navigator.share({
      //         title: 'Motiners',
      //         url: `https://plink.motiners.com/?link=${currURL}&apn=com.motiners.bundle&isi=1556370860&ibi=com.motiners.motinersapp&st=${shareTitle}&sd=${shareDescription}&si=${shareImg}`
      //       })
      //     }
      //     else
      //     {
      //       kakaoButton.current.click();
      //     }
      //   }
      //   else
      //   {
      //     kakaoButton.current.click();
      //   }
      // }
      kakaoButton.current.click();
    }
    catch(error)
    {
      console.log(error);
    }
  };


  const goBack = () => {
    let prevPath = history.location;
    history.goBack();
    setTimeout(()=>{
      let newPath = history.location;
      if(prevPath === newPath)
      {
        history.replace('/');
      }
    },100)
  };
  return (
    <TopInner style={{ borderBottom: borderbottom }}>
      <BackButtonarea>
      <Back onClick={goBack}>
        <img src={arrow_icon}></img>
      </Back>
      </BackButtonarea>
      <Title>
        <Titletxt>
          {groupInfo.visibility == 'public' ? null : (
            <Lock>
              <img src={lock_gray}></img>
            </Lock>
          )}
          {groupInfo.title}
        </Titletxt>
      </Title>
      <Buttonarea>
        <Share onClick={clickShareButton}>
          <img src={share_icon}></img>
        </Share>
        <Helmet>
          <script src="https://developers.kakao.com/sdk/js/kakao.js"></script>
        </Helmet>
        <KakaoShareButton
          queryString={shareQueryString}
          kakaoButton={kakaoButton}
          shareTitle={groupInfo['title']} 
          shareDescription={groupInfo['description']} 
          shareImg={(groupInfo['group_cover_img'])?`${constants.imagePath}/group_cover_img/${groupInfo['group_cover_img']}`:null}
        ></KakaoShareButton>
        {groupInfo['is_member'] ? <DotButton onClick={handleModal} style={{marginLeft: 'calc(100vw * (15 / 375))'}}/> : null}
      </Buttonarea>
    </TopInner>
  );
}

const TopInner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 200;
  width: 100%;
  height: calc(100vw * (51 / 375));
  display: flex;
  align-items: center;
  padding: 0 calc(100vw * (17 / 375));
`;

const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  letter-spacing: 0.32px;
  // margin-left: calc(100vw*(131.2/375));
`;

const Titletxt = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
  text-align: center;
`;

const BackButtonarea = styled.div`
width: calc(100vw * (45/375));
`;

const Back = styled.a`
  // display: block;
  width: calc(100vw * (9.8 / 375));
  height: calc(100vw * (16 / 375));
`;

const Share = styled.a`
  display: block;
  width: calc(100vw * (15 / 375));
  height: calc(100vw * (16 / 375));
`;

const Lock = styled.a`
  width: calc(100vw * (12 / 375));
  height: calc(100vw * (15 / 375));
  margin-right: calc(100vw * (5.4 / 375));
`;

const Buttonarea = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: calc(100vw * (45/375))
`;

const Spacer = styled.div`
  height: calc(100vw * (90 / 375));
`;